// Investor pitch deck - business case + technical validation
import {
  SlidePresenter,
  BusinessSlide,
  TechSlide,
} from "../../sections/BrandSlides";

const slides = [BusinessSlide, TechSlide];

export default function InvestorDeck() {
  return <SlidePresenter slides={slides} />;
}
